import React from 'react';
import Popup from 'react-popup';

import Form from './Form';

import AuthorizationApi from '../../Api/Authorization';
import snackbar from '../../snackbar';

Popup.registerPlugin('driverForm', function plugin(driver = {}) {
  this.create({
    title: 'Formulário de Motorista',
    className: 'popup',
    content: (
      <Form
        driver={driver}
        onClose={() => this.close()}
      />
    ),
  });
});


export default function (driver) {
  if (AuthorizationApi.cannot(AuthorizationApi.Actions.UPDATE, AuthorizationApi.Entities.DRIVER)) {
    snackbar.show({
      text: 'Acesso negado!',
    });
    return;
  }
  Popup.plugins().driverForm(driver);
}



// WEBPACK FOOTER //
// ./src/Driver/DriverFormPopup/index.js